import {put, takeLatest } from "redux-saga/effects";
import { onSegmentError, onSegmentSubmit, onSegmentSuccess } from "../Store/Slices/SegmentSlice";

function* Segment({ payload }) {
    try {
        if (payload.status_code === "200") { 
            yield put(
                onSegmentSuccess({
                    data: payload.data,
                    status_code:payload.status_code,
                })
            );  
        } else {
            yield put(
                onSegmentError({
                    data: payload.error,
                })
            );
        }
    } catch (error) {
    }
}
export default function* SegmentSaga() {
    yield takeLatest(onSegmentSubmit.type, Segment);
}
